module.exports = __webpack_public_path__ + "img/padRight.a552ccca.png";